/**
 * Direct import of UILIB components is necessary due to an incompatibility with esbuild caused by UILIB's incorrect import of normalize.css
 * UILIB core
 */

import { Link as RouterLink } from '@tanstack/react-router'
import IconMapsGlobe from '@uilib/assets-consumer-icons/IconMapsGlobe'
import IconStatusCheckSquareColor from '@uilib/assets-consumer-icons/IconStatusCheckSquareColor'
// UILIB icons
import IconStatusExclamationTriangleColor from '@uilib/assets-consumer-icons/IconStatusExclamationTriangleColor'
import LogoEhInlineColor from '@uilib/assets-consumer-logos/LogoEhInlineColor'
import LogoEmsInlineColor from '@uilib/assets-consumer-logos/LogoEmsInlineColor'
import * as utils from '@uilib/consumer-components/_utils'
import { colorPalette } from '@uilib/consumer-components/_utils/colors'
import consumerConstants from '@uilib/consumer-components/_utils/constants'
import Theme, { type ThemeType } from '@uilib/consumer-components/_utils/theme'
/**
 * UILIB consumer-components
 */
import App from '@uilib/consumer-components/App'
import Button, { type ButtonProps } from '@uilib/consumer-components/Button'
import Divider from '@uilib/consumer-components/Divider'
import FloatingButton from '@uilib/consumer-components/FloatingButton'
import FloatingPanel, {
  floatingPanelDefaultMiddleware,
} from '@uilib/consumer-components/FloatingPanel'
import Headline from '@uilib/consumer-components/Headline'
import Link from '@uilib/consumer-components/Link'
import ListSelector from '@uilib/consumer-components/ListSelector'
import type ListSelectorItemType from '@uilib/consumer-components/ListSelector/ListSelector.types'
import LoadingDots from '@uilib/consumer-components/LoadingDots'
import Text from '@uilib/consumer-components/Text'
import type { IconProps } from '@uilib/core'
import coreConstants from '@uilib/core/_utils/constants'
import FlexContainer, {
  type FlexContainerProps,
} from '@uilib/core/FlexContainer'
import { floatingPanelUtils } from '@uilib/core/FloatingPanelCore'
import Grid from '@uilib/core/Grid'
import type { ColumnSizeType } from '@uilib/core/Grid/Column'
import Column from '@uilib/core/Grid/Column/Column'
import Row from '@uilib/core/Grid/Row/Row'
import { mediaQueryHookQueries, useMediaQuery } from '@uilib/core/MediaQuery'
import Spacer from '@uilib/core/Spacer'

const colors = {
  ...colorPalette,
  lightGrey: 'rgba(255, 255, 255, 0.70)',
  errorPrimaryHover: '#b41a08',
  lightBlueBackground: 'rgba(24, 125, 175, 0.10)',
  dropdownBackground: '#ebebeb',
}

const constants = {
  core: coreConstants,
  consumer: consumerConstants,
}

export type {
  ButtonProps,
  ColumnSizeType,
  FlexContainerProps,
  IconProps,
  ListSelectorItemType,
  ThemeType,
}

export {
  App,
  Button,
  Column,
  colors,
  constants,
  Divider,
  FlexContainer,
  FloatingButton,
  FloatingPanel,
  floatingPanelDefaultMiddleware,
  floatingPanelUtils,
  Grid,
  Headline,
  IconMapsGlobe,
  IconStatusCheckSquareColor,
  IconStatusExclamationTriangleColor,
  Link,
  ListSelector,
  LoadingDots,
  LogoEhInlineColor,
  LogoEmsInlineColor,
  mediaQueryHookQueries,
  RouterLink,
  Row,
  Spacer,
  Text,
  Theme,
  useMediaQuery,
  utils,
}
